/**
 * @generated SignedSource<<c1f350bf7cdcc497818b46d7f2e9a487>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type SubjectUrnTypeEnum = "Email" | "Integration" | "Org" | "Person" | "Phone" | "Services" | "Team" | "User" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EventSummaryAutopilotFlex_event$data = {
  readonly annotatedEvent: {
    readonly orgTags: ReadonlyArray<{
      readonly tag: string;
      readonly state: {
        readonly active: boolean;
        readonly value: string | null;
        readonly subjectType: SubjectUrnTypeEnum;
      };
    }> | null;
  } | null;
  readonly annotatedRecurringEvent: {
    readonly orgTags: ReadonlyArray<{
      readonly tag: string;
      readonly state: {
        readonly active: boolean;
        readonly value: string | null;
        readonly subjectType: SubjectUrnTypeEnum;
      };
    }> | null;
  } | null;
  readonly " $fragmentType": "EventSummaryAutopilotFlex_event";
};
export type EventSummaryAutopilotFlex_event$key = {
  readonly " $data"?: EventSummaryAutopilotFlex_event$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventSummaryAutopilotFlex_event">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "OrgTag",
    "kind": "LinkedField",
    "name": "orgTags",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "tag",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TagState",
        "kind": "LinkedField",
        "name": "state",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "value",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subjectType",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventSummaryAutopilotFlex_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AnnotatedEvent",
      "kind": "LinkedField",
      "name": "annotatedEvent",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AnnotatedEvent",
      "kind": "LinkedField",
      "name": "annotatedRecurringEvent",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "85897e174c67a0eec0daf9e989a1bd19";

export default node;
